import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  IconButton,
  Grid,
} from '@mui/material';
import {
  CreditCard as CreditCardIcon,
  AccountBalance as BankIcon,
  AccountBalanceWallet as WalletIcon,
  AttachMoney as MoneyIcon,
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
  Download as DownloadIcon,
  Payment as PaymentIcon,
} from '@mui/icons-material';
import { formatCurrency } from '../../../utils/helper';

const PaymentHistory = ({ payment_history = [] }) => {
  const getPaymentStatusColor = (status) => {
    switch (status) {
      case 'PS': return 'success';
      case 'PD': return 'warning';
      case 'IN': return 'info';
      case 'RT': return 'error';
      case 'FD': return 'error';
      default: return 'default';
    }
  };

  const getPaymentModeIcon = (mode) => {
    switch (mode) {
      case 'CR':
      case 'DB':
        return <CreditCardIcon />;
      case 'BT':
        return <BankIcon />;
      case 'CS':
        return <WalletIcon />;
      default:
        return <MoneyIcon />;
    }
  };

  if (payment_history.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Avatar sx={{ bgcolor: 'grey.400', width: 64, height: 64, mx: 'auto', mb: 2 }}>
          <PaymentIcon sx={{ fontSize: 32 }} />
        </Avatar>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          No Payment History
        </Typography>
        <Typography variant="body2" color="text.secondary">
          No payments have been made for this invoice yet.
        </Typography>
      </Box>
    );
  }

  return (
    <Card sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
      <CardContent sx={{ p: 0 }}>
        {/* Payment Table */}
        <TableContainer component={Paper} sx={{ boxShadow: 'none' }}>
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Payment Method</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Amount</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Reference</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Date & Time</TableCell>
                <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Remarks</TableCell>
                {/* <TableCell sx={{ fontWeight: 600, fontSize: '0.875rem' }}>Actions</TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {payment_history.map((payment) => (
                <TableRow key={payment.id} hover sx={{ '&:hover': { bgcolor: '#f5f5f5' } }}>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar 
                        sx={{ 
                          bgcolor: 'primary.main', 
                          mr: 2, 
                          width: 32, 
                          height: 32,
                          fontSize: '0.875rem'
                        }}
                      >
                        {getPaymentModeIcon(payment.payment_mode)}
                      </Avatar>
                      <Typography variant="body2" sx={{ fontWeight: 500 }}>
                        {payment.payment_mode_verbose}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'success.main' }}>
                      {formatCurrency(payment.amount)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={payment.status_verbose}
                      color={getPaymentStatusColor(payment.status)}
                      size="small"
                      icon={payment.status === 'PS' ? <CheckCircleIcon /> : <ScheduleIcon />}
                      sx={{ 
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        height: 24
                      }}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontFamily: 'monospace', 
                        fontWeight: 500,
                        fontSize: '0.75rem',
                        color: 'text.secondary'
                      }}
                    >
                      {payment.payment_reference}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                      {payment.payment_date_time}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
                      {payment.remarks || '-'}
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    {payment.payment_reciept && (
                      <Tooltip title="Download Receipt">
                        <IconButton
                          size="small"
                          onClick={() => window.open(payment.payment_reciept, '_blank')}
                          sx={{ 
                            color: 'primary.main',
                            '&:hover': { bgcolor: 'primary.light', color: 'white' }
                          }}
                        >
                          <DownloadIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    )}
                  </TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default PaymentHistory;
